// src/i18n.ts
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  // Carica i file di traduzione in modo asincrono
  .use(HttpApi)
  // Rileva automaticamente la lingua del browser
  .use(LanguageDetector)
  // Inizializza i18next per React
  .use(initReactI18next)
  .init({
    fallbackLng: 'it', // lingua di fallback italiano
    lng: 'it', // lingua predefinita italiano
    debug: false,
    ns: ['common', 'dataGrid', 'filters', 'reports', 'login', 'retentionGovernance', 'users'], // namespace usati nei file JSON
    defaultNS: 'common',
    backend: {
      // Percorso per il caricamento dei file di traduzione
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    react: {
      useSuspense: true, // Attende il caricamento delle traduzioni
    },
  });

export default i18n;
